<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">약속상품 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">약속상품명</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_nm">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">상품이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_goodsFileUpload">파일업로드</button>
                        <input type="file" ref="goodsFile" @change="fn_fileGoodsChange" hidden>
                        <ul class="file_list" v-if="regData.goods_file_nm != ''">
                            <li>{{regData.goods_file_nm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">출전</span></th>
                  <td>
                      <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.promise_goods_source">
                  </td>
                </tr>                
                <tr>
                  <th><span class="emp">상품타입</span></th>
                  <td>
                    <div class="form_select"> 
                      <b-form-select v-model="regData.promise_goods_type">
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in goodsTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>              
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">조제단위</span></th>
                  <td>
                    <div class="form_select">
                      <b-form-select v-model="regData.prepare_unit">
                        <b-form-select-option :value="null">선택</b-form-select-option>
                        <b-form-select-option v-for="(item, index) in packageUnitList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                      </b-form-select>
                    </div>              
                  </td>
                </tr>
                <tr>
                  <th><span>약속상품설명</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="regData.component_descript"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>처방구성</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="regData.prescript_component"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>구성안내</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" v-model="regData.component_guide"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>복용법</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" placeholder="입력해주세요." v-model="regData.take_method"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>포장안내</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" placeholder="입력해주세요." v-model="regData.package_guide"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>배송안내</span></th>
                  <td>
                    <textarea class="form_control" style="line-height: 20px;" placeholder="입력해주세요." v-model="regData.delivery_guide"></textarea>
                  </td>
                </tr>
                <tr>
                  <th><span>옵션상품</span></th>
                  <td>
                    <div class="table_list">
                      <div class="table_option">
                        <div class="form_select"></div>
                        <button class="btn btn_md btn_blue" @click="fn_call_optionGoodsModal">옵션상품 추가</button>
                      </div>
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="*">
                          <col width="150">
                          <col width="80">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>순서</th>
                            <th>이미지</th>
                            <th>옵션상품명</th>
                            <th>가격</th>
                            <th>처리</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="regData.optionGoodsList.length == 0">
                              <td colspan="5"><span>데이터가 없습니다.</span></td>
                          </tr>
                          <tr v-for="(item, index) in regData.optionGoodsList" :key="index">
                            <td>
                              <input type="number" class="form_control" min="1" v-model.number="item.sort_ord">
                            </td>
                            <td>
                              <span class="img_area">
                                <img :src="'/file/getImgFile/' + item.option_goods_file_id" alt="">
                              </span>
                            </td>
                            <td><span>{{ item.option_goods_nm }}</span></td>
                            <td><span>{{ fn_comma_won(item.option_goods_price) }}</span></td>
                            <td><button class="icon icon_del" @click="fn_optionGoods_delete(index)"></button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">상품노출여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="radio1" name="display_yn" value="Y" v-model="regData.display_yn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="radio2" name="display_yn" value="N" v-model="regData.display_yn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>                 
                <tr>
                  <th><span>기준재고량</span></th>
                  <td>
                    <input type="text" class="form_control" placeholder="입력해주세요." v-model="regData.stdr_invt_qy">
                  </td>
                </tr>    
                <!-- <tr>
                  <th><span class="emp">상세정보 입력방식</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio" id="sel1" name="select" 
                          @change="isEditVisible = false, isImgVisible = true"  
                          checked
                        >
                        <label for="sel1">이미지 </label>
                      </div>
                      <div class="form_radio">
                        <input type="radio" id="sel2" name="select" 
                          @change="isImgVisible = false, isEditVisible = true"  
                        >
                        <label for="sel2">에디트박스 </label>
                      </div>
                    </div>                   
                  </td>
                </tr> -->
                <tr>
                  <th><span class="emp">상세정보 이미지</span></th>
                  <td>
                    <div class="form_inline">
                        <button class="btn btn_md btn_blue" @click="fn_goodsInfoFileUpload">파일업로드</button>
                        <input type="file" ref="goodsInfoFile" @change="fn_fileGoodsInfoChange" hidden>
                        <ul class="file_list" v-if="regData.goods_info_file_nm != ''">
                            <li>{{regData.goods_info_file_nm}}</li>
                        </ul>
                    </div>
                  </td>
                </tr>
                <!-- <tr v-else>
                  <th><span class="emp">상세정보</span></th>
                  <td>
                    <Editor/>
                  </td>
                </tr> -->
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline"  @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg_promise_goods">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <OptionGoodsSearch
        :title="'옵션상품 검색'"
        :searchName="'옵션상품명'"
        :btnLeft="'선택'"
        :btnRight="'취소'"
        :oneBtn="true"
        @callback="fn_optionGoods_callback"
      />
      <alert-modal
            :id="'alert'"
            :text="showAlertMsg" 
            :btnRight="'확인'" 
            :oneBtn="false"
            :isShow="showAlert"
            :className="'btn_brown'"
            v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
  import axios from 'axios'
  import AlertModal from "@/modal/common/alertModal.vue"
  import OptionGoodsSearch from "@/modal/admin/optionGoodsSearch.vue"
  import commonUtil from "@/mixin/commonUtil";
  import alertutill from "@/mixin/alertModalUtill";

  export default {
    name: 'PromiseGoodsReg',
    mixins: [alertutill,commonUtil],
    components: {
      'alert-modal' : AlertModal,
      OptionGoodsSearch,
    },
    data() {
      return {
        goodsTypeList : [],       // 상품타입 리스트
        packageUnitList : [],      // 포장단위 리스트
        regData : {
          promise_goods_cd : '',
          promise_goods_nm : '',
          promise_goods_type : null,
          promise_goods_source : '',
          prepare_unit : null,
          component_descript : '',    //상품설명
          component_guide : '',       // 구성가이드
          prescript_component : '',   // 처방구성
          take_method : '',           // 복용법
          package_guide : '',         // 포장안내
          delivery_guide : '',        // 배송안내
          optionGoodsList : [],     // 옵션상품 리스트
          display_yn : 'Y',
          stdr_invt_qy : 0,
          goods_file_nm : '',
          goods_info_file_nm : '',
          //promise_goods_price : 0,
          status : ''
        },
        upLoadFile : {
            goods_file : '',
            goods_info_file : ''
        },
      }
    },
    async created(){
        //공통코드 - 상품타입가져오기
        this.goodsTypeList = await this.getCode('GC00000008');        
        
        //공통코드 - 조제단위가져오기
        this.packageUnitList = await this.getCode('GC00000009');  

        this.regData.status = this.$store.getters['promise/getStatus'];

        if(this.regData.status == 'M'){
          this.regData.promise_goods_cd = this.$store.getters['promise/getPromiseGoodsCd'];  
          this.fn_search(); 
        }

    },
    methods : {
      fn_goodsFileUpload(){
          let fileInputElement = this.$refs.goodsFile;
          fileInputElement.click();
      },
      fn_fileGoodsChange(e){
          this.upLoadFile.goods_file = e.target.files[0];
          this.regData.goods_file_nm = this.upLoadFile.goods_file.name;
      },
      fn_goodsInfoFileUpload(){
          let fileInputElement = this.$refs.goodsInfoFile;
          fileInputElement.click();
      },
      fn_fileGoodsInfoChange(e){
          this.upLoadFile.goods_info_file = e.target.files[0];
          this.regData.goods_info_file_nm = this.upLoadFile.goods_info_file.name;
      },
      fn_call_optionGoodsModal(){
        this.$bvModal.show("optionGoodsSearch");
      },
      fn_optionGoods_callback(optionList){
        //이미 추가된 옵션상품은 제외
        optionList.forEach(option => {
          let exists = this.regData.optionGoodsList.some(item => item.option_goods_seq == option.option_goods_seq);
          if(!exists){
            //순서는 현재 최대 순서 다음 번호로 기본 세팅
            let maxOrder = this.regData.optionGoodsList.reduce((max, item) => Math.max(max, Number(item.sort_ord) || 0), 0);
            this.regData.optionGoodsList.push({ ...option, sort_ord : maxOrder + 1 });
          }
        });
      },
      fn_optionGoods_delete(idx){
        this.regData.optionGoodsList.splice(idx,1);
      },
      fn_reg_promise_goods(){

        if(this.fn_validation_chk()){

            var frm = new FormData();
   
            frm.append("file",this.upLoadFile.goods_file);
            frm.append("file2",this.upLoadFile.goods_info_file);
            frm.append("key",JSON.stringify(this.regData));
            

            axios
                .post("/api/admin/promise/regPromiseGoodsWithFile", frm, {
                        "Content-Type": "multipart/form-data",
                        "Accept-Language" : "ko"})
                .then((res) => {                            
                    console.log("@@@@ res : %o",res);
                    if(res.data.result == "ok"){
                        // let msg = "저장되었습니다";
                        // this.fn_open_alert(msg);
                        alert("저장되었습니다.");
                        this.fn_move_page();  
                    }else{
                        let msg = res.data.errorMsg;
                        this.fn_open_alert(msg);
                    } 
                    
                })
                .catch((err) => console.log(err));
        }
        
      },
      fn_validation_chk(){
        if(this.regData.promise_goods_nm == ''){
            alert("약속상품을 입력해주세요");    
            return false;
        }

        if(this.regData.goods_file_nm == ''){
            alert("상품이미지를 선택해주세요");    
            return false;
        }

        if(this.regData.promise_goods_type == null){
            alert("상품타입를 선택해주세요");    
            return false;
        }

        // if(this.regData.promise_goods_quantity == ''){
        //     alert("상품수량을 선택해주세요");    
        //     return false;
        // }

        if(this.regData.prepare_unit == ''){
            alert("제조단위를 선택해주세요");    
            return false;
        }

        // if(this.regData.promise_goods_price <= 0 || this.regData.promise_goods_price == ''){
        //     alert("약속상품가격을 입력해주세요");    
        //     return false;
        // }

        if(this.regData.goods_info_file_nm == ''){
            alert("상품정보이미지를 선택해주세요");
            return false;
        }

        //옵션상품 순서 체크
        let orderList = this.regData.optionGoodsList.map(item => item.sort_ord);
        if(orderList.some(order => !Number.isInteger(order) || order < 1)){
            alert("옵션상품 순서를 1 이상의 숫자로 입력해주세요");
            return false;
        }
        if(new Set(orderList).size != orderList.length){
            alert("옵션상품 순서가 중복되었습니다");
            return false;
        }

        return true;
      },
      fn_move_page(){
            this.$router.push("/admin/promise/promiseGoodsMngt");
      },
      fn_search(){

        let param = new Object();
        param.promise_goods_cd = this.regData.promise_goods_cd;

        console.log("@@@@ param : %o",param);

        axios
            .post("/api/admin/promise/promiseGoodsDetail", param)
            .then((res) => {
                console.log("@@@@ dtl res : %o",res);
              
                this.regData.promise_goods_nm = res.data.promise_goods_nm;
                this.regData.promise_goods_source = res.data.promise_goods_source;
                this.regData.promise_goods_type = res.data.promise_goods_type;
                this.regData.promise_goods_quantity = res.data.promise_goods_quantity;
                this.regData.prepare_unit = res.data.prepare_unit;
                this.regData.component_descript = res.data.component_descript;
                this.regData.component_guide = res.data.component_guide;
                this.regData.prescript_component = res.data.prescript_component;
                this.regData.take_method = res.data.take_method;
                this.regData.package_guide = res.data.package_guide;
                this.regData.delivery_guide = res.data.delivery_guide;
                this.regData.display_yn = res.data.display_yn;
                this.regData.stdr_invt_qy = res.data.stdr_invt_qy;
                this.regData.take_method = res.data.take_method;
                this.regData.stdr_invt_qy = res.data.stdr_invt_qy;
                this.regData.stdr_invt_qy = res.data.stdr_invt_qy;
                this.regData.goods_file_id = res.data.goods_file_id;
                this.regData.goods_info_file_id = res.data.goods_info_file_id;
                this.regData.promise_goods_price = res.data.promise_goods_price;
                this.regData.goods_file_nm = res.data.goods_file_nm;
                this.regData.goods_info_file_nm = res.data.goods_info_file_nm;
                this.regData.optionGoodsList = res.data.optionGoodsList || [];
            })
            .catch((err) => console.log(err));
              
      },
    }
  }
</script>